webpackJsonp([1135276415346],{

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ButtonModule = __webpack_require__(38);
	
	var _ButtonModule2 = _interopRequireDefault(_ButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var color = _ref.color,
	        text = _ref.text,
	        clicked = _ref.clicked,
	        styles = _ref.styles,
	        loading = _ref.loading,
	        _ref$disabled = _ref.disabled,
	        disabled = _ref$disabled === undefined ? false : _ref$disabled;
	
	
	    var buttonStyles = [_ButtonModule2.default.Button];
	    if (color === 'primary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Primary].join(' ');
	    }
	
	    if (color === 'primary' && loading) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonLoading].join(' ');
	    }
	
	    if (color === 'primary' && disabled) {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.PrimaryButtonDisabled].join(' ');
	    }
	
	    if (color === 'secondary') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Secondary].join(' ');
	    }
	
	    if (color === 'transparent') {
	        buttonStyles = [_ButtonModule2.default.Button, _ButtonModule2.default.Transparent].join(' ');
	    }
	
	    return _react2.default.createElement(
	        'button',
	        {
	            className: buttonStyles,
	            onClick: clicked,
	            style: styles,
	            disabled: loading ? loading : disabled },
	        loading ? "Loading..." : text
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-componentsEn-Button----Button-module---Button---2JTlm","Primary":"src-componentsEn-Button----Button-module---Primary---_dSAO","PrimaryButtonLoading":"src-componentsEn-Button----Button-module---PrimaryButtonLoading---1p514","PrimaryButtonDisabled":"src-componentsEn-Button----Button-module---PrimaryButtonDisabled---D3iR5","Secondary":"src-componentsEn-Button----Button-module---Secondary---aGVMu","Transparent":"src-componentsEn-Button----Button-module---Transparent---3PMbj"};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactSlick = __webpack_require__(103);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(201);
	
	var _accountCircle = __webpack_require__(105);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { style: { backgroundColor: '#1689DF', color: '#fff' } },
	            _react2.default.createElement(
	                'div',
	                { style: { maxWidth: 1170, padding: '20px 20px 40px', margin: 'auto' } },
	                _react2.default.createElement(SimpleSlider, null)
	            )
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	
	var AvatarImage = function AvatarImage(_ref) {
	    var alt = _ref.alt;
	    return _react2.default.createElement('img', { src: _accountCircle2.default, alt: alt, style: { with: 44, height: 34, marginRight: 6, marginBottom: 0 } });
	};
	
	var TestimonialItem1 = function TestimonialItem1() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'So impressed with this service. The psychotherapist listen attentively and responds with clarity, experience and calmness. For me, the connection was immediate and relaxing during a trying time. Many thanks !!'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'Matt Gervais picture' }),
	            ' Matt Gervais, Rockland'
	        )
	    );
	};
	
	var TestimonialItem2 = function TestimonialItem2() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'I would not have been here without the CPM constant help and guidance. Thank you !'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'Audrey Pirker review, picture' }),
	            ' Audrey Pirker, Ottawa'
	        )
	    );
	};
	
	var TestimonialItem3 = function TestimonialItem3() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'I like CPM. I found an excellent practitioner there, highly knowledgeable in her field. She was patient and extremely kind. I credit her with her very sharp observations of my issues in the relatively limited time we spent together. Overall going there was a good decision.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'David Schmid picture' }),
	            ' David Schmid, Ottawa'
	        )
	    );
	};
	
	var TestimonialItem4 = function TestimonialItem4() {
	    return _react2.default.createElement(
	        'div',
	        { style: { padding: "20px 20px 10px" } },
	        _react2.default.createElement(
	            'em',
	            null,
	            'I found them to be very supportive at a time when I felt the whole world was against me. Going there has been extremely helpful and I appreciate that my therapist was challenging my negative thoughts about myself.'
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: '20px 0 0', display: 'flex', alignItems: 'center' } },
	            _react2.default.createElement(AvatarImage, { alt: 'Jennifer Ballard picture' }),
	            ' Jennifer Ballard, Ottawa'
	        )
	    );
	};
	
	var SimpleSlider = function (_React$Component) {
	    _inherits(SimpleSlider, _React$Component);
	
	    function SimpleSlider() {
	        _classCallCheck(this, SimpleSlider);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    SimpleSlider.prototype.render = function render() {
	        var settings = {
	            dots: true,
	            infinite: true,
	            speed: 500,
	            slidesToShow: 1,
	            slidesToScroll: 1,
	            autoplay: true,
	            autoplaySpeed: 7000,
	            dotsClass: 'slick-dots'
	        };
	        return _react2.default.createElement(
	            _reactSlick2.default,
	            settings,
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem1, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem2, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem3, null)
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(TestimonialItem4, null)
	            )
	        );
	    };
	
	    return SimpleSlider;
	}(_react2.default.Component);
	
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"HowItWorks":"src-componentsEn-Contents----Content-module---HowItWorks---3hkCo","ServiceList":"src-componentsEn-Contents----Content-module---ServiceList---1ng5d","DefinitionsTab":"src-componentsEn-Contents----Content-module---DefinitionsTab---_EDZ6","TabItemList":"src-componentsEn-Contents----Content-module---TabItemList---3GwxU","Active":"src-componentsEn-Contents----Content-module---Active---TYrji","MobileTabTitle":"src-componentsEn-Contents----Content-module---MobileTabTitle---15A_B","MobileTabWrapper":"src-componentsEn-Contents----Content-module---MobileTabWrapper---399o-","MobileTabContent":"src-componentsEn-Contents----Content-module---MobileTabContent---2qc5i","MoreInfoWrapper":"src-componentsEn-Contents----Content-module---MoreInfoWrapper---3KewU","MoreInfoItem":"src-componentsEn-Contents----Content-module---MoreInfoItem---1H6wv","Horaire":"src-componentsEn-Contents----Content-module---Horaire---2FUrg","PhoneNumberInfo":"src-componentsEn-Contents----Content-module---PhoneNumberInfo---rlnWJ","MoreInfoItemTitle":"src-componentsEn-Contents----Content-module---MoreInfoItemTitle---2stQS","CheckIcon":"src-componentsEn-Contents----Content-module---CheckIcon---Wm3Vv","WhyItemTitle":"src-componentsEn-Contents----Content-module---WhyItemTitle---xwbcJ","SideImageWhyUs":"src-componentsEn-Contents----Content-module---SideImageWhyUs---1wuHa","SideImageTherapies":"src-componentsEn-Contents----Content-module---SideImageTherapies---3oqQG","SideContentWrapper":"src-componentsEn-Contents----Content-module---SideContentWrapper---12-5C","TherapieIndividuelle":"src-componentsEn-Contents----Content-module---TherapieIndividuelle---cmNQT","TherapieCoupleWrapper":"src-componentsEn-Contents----Content-module---TherapieCoupleWrapper---32-xu","TherapieCouple":"src-componentsEn-Contents----Content-module---TherapieCouple---1AAIt","PsychoeducationWrapper":"src-componentsEn-Contents----Content-module---PsychoeducationWrapper---2BFqi","SideImageWrapper":"src-componentsEn-Contents----Content-module---SideImageWrapper---3aDUN","GetStartedWrapper":"src-componentsEn-Contents----Content-module---GetStartedWrapper---1YqeK","GetStartedItem":"src-componentsEn-Contents----Content-module---GetStartedItem---BB9ut","BenefitsImage":"src-componentsEn-Contents----Content-module---BenefitsImage---2dKyG","BenefitsWrapper":"src-componentsEn-Contents----Content-module---BenefitsWrapper---wGHfd","BenefitsTextWrapper":"src-componentsEn-Contents----Content-module---BenefitsTextWrapper---2zeJR","AGetStarted":"src-componentsEn-Contents----Content-module---AGetStarted---3-N8z"};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentModule = __webpack_require__(20);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _servicesImage = __webpack_require__(115);
	
	var _servicesImage2 = _interopRequireDefault(_servicesImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.BenefitsWrapper },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 585, padding: '40px 20px', margin: 'auto' }, className: _ContentModule2.default.BenefitsTextWrapper },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 40 } },
	                'What are the benefits of therapy?'
	            ),
	            _react2.default.createElement('div', { style: { width: 100, height: 2, backgroundColor: '#1689DF', marginBottom: 40 } }),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'It is often easier to talk to strangers than to relatives or friends. During therapy, a qualified counselor or therapist listens to you and helps you find your own answers to problems, without judging you.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'The therapist will give you time to talk, cry, scream or just think. This is an opportunity to look at your problems differently with someone who will respect you and your opinions.'
	                )
	            )
	        ),
	        _react2.default.createElement('div', { className: _ContentModule2.default.BenefitsImage, style: { backgroundImage: 'url(' + _servicesImage2.default + ')' } })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var clicked = _ref.clicked;
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#F6F6F6' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 700, padding: '60px 20px', margin: 'auto', textAlign: 'center' } },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 16 } },
	                'Why wait to feel better?'
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Book an appointment to start a positive change in your life.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_Button2.default, { color: 'primary', text: 'Book Online', clicked: function clicked() {
	                            return (0, _gatsbyLink.navigateTo)('/en/booking');
	                        } }),
	                    _react2.default.createElement(
	                        'a',
	                        { className: '',
	                            href: 'tel:+16132525227',
	                            style: { marginLeft: 20 }
	                        },
	                        _react2.default.createElement(_Button2.default, { color: 'secondary', text: '613-252-5227' })
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 900, padding: '40px 20px', margin: 'auto', fontSize: '1.1rem' } },
	            _react2.default.createElement(
	                'p',
	                null,
	                'Welcome on behalf of our team. The CPM is a multidisciplinary health centre staffed by a group of psychologists, marriage and family counselors providing counselling and therapies in the Ottawa and Gatineau regions. We offer individual, couple and family counselling. Our most important objective is that you feel listened to and understood in your current difficulties. We operate in a confidential and welcoming environment.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Our therapists employ integrative and client-centred approaches. Cognitive and Behavioral Therapy (CBT), Solution-Focused Therapies, Psychodynamic Therapy, Neurolinguistic Programming (NLP) and many more.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We use a variety of family therapy approaches aimed at improving family communication and functioning, resolving interpersonal conflicts, and developing coping and problem-solving skills in families.'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Our therapists are at your service and are ready to help you find ways to overcome the challenges you face.'
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _ContentModule = __webpack_require__(20);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: 'rgb(246, 246, 246)' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto', textAlign: 'center' } },
	            _react2.default.createElement(
	                'h2',
	                { style: { marginBottom: 40 } },
	                'How to get started?'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.GetStartedWrapper },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '1'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'How to get started? ',
	                        _react2.default.createElement(
	                            'span',
	                            { onClick: function onClick() {
	                                    return (0, _google_conversion_mobile_call2.default)();
	                                } },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'tel:+16132525227' },
	                                '613-252-5227'
	                            )
	                        ),
	                        ' (or ',
	                        _react2.default.createElement(
	                            _gatsbyLink2.default,
	                            { to: '/en/booking' },
	                            'book online'
	                        ),
	                        ') and share your problems with us.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '2'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We will provide you with therapists specifically adapted to your needs.'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.GetStartedItem, style: { display: 'flex', alignItems: 'center', flexDirection: 'column' } },
	                    _react2.default.createElement(
	                        Number,
	                        null,
	                        '3'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Meet with your therapist and start the journey to improve yourself.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	var Number = function Number(_ref) {
	    var children = _ref.children;
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                justifyContent: 'center',
	                alignItems: 'center',
	                width: 40,
	                height: 40,
	                borderRadius: '50%',
	                color: '#fff',
	                backgroundColor: '#4cae4c',
	                marginBottom: 20,
	                fontSize: '1.5rem'
	            } },
	        children
	    );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _gatsbyLink = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#1689DF', color: '#fff' } },
	        _react2.default.createElement(
	            'div',
	            { style: {
	                    maxWidth: 800,
	                    margin: 'auto',
	                    padding: '40px 20px',
	                    minHeight: 320,
	                    display: 'flex',
	                    alignItems: 'center',
	                    justifyContent: 'center',
	                    flexDirection: 'column'
	                } },
	            _react2.default.createElement(
	                'h1',
	                { style: { textAlign: 'center' } },
	                'We are there to help you'
	            ),
	            _react2.default.createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                'Our consultants work in full confidentiality and adapt their approach to your specific needs. Your therapy begins with you taking an appointment, which is the first step towards gradual change.'
	            ),
	            _react2.default.createElement(_Button2.default, { color: 'transparent', text: 'TAKE AN APPOINTMENT', clicked: function clicked() {
	                    return (0, _gatsbyLink.navigateTo)('/en/booking');
	                } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Iframe = __webpack_require__(64);
	
	var _Iframe2 = _interopRequireDefault(_Iframe);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _ContentModule = __webpack_require__(20);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _iconOrloge = __webpack_require__(110);
	
	var _iconOrloge2 = _interopRequireDefault(_iconOrloge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var isMobile = _ref.isMobile,
	        history = _ref.history;
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#4D4D4D' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto' } },
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.MoreInfoWrapper },
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody },
	                        _react2.default.createElement(_Iframe2.default, { width: '100%', height: '240px', src: 'https://www.google.com/maps/embed/v1/place?key=AIzaSyD5d58sVD8JymoPG0mWxmQP8glK9_m9cI4&q=427+McArthur+Ave,Ottawa,ON' })
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem, style: { backgroundColor: '#fff', marginBottom: '' + (isMobile ? '20px' : 0) } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemTitle },
	                        'Take an Appointment'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody, style: { padding: 20 } },
	                        _react2.default.createElement(
	                            'h2',
	                            { style: { margin: 0 }, className: _ContentModule2.default.PhoneNumberInfo },
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'tel:+16132525227', target: '_blank', style: { textDecoration: 'underline' }, onClick: function onClick() {
	                                        return (0, _google_conversion_mobile_call2.default)();
	                                    } },
	                                '613-252-5227'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'h5',
	                            { style: { color: "#92c83a", marginBottom: 10 } },
	                            '\u2022 Line Available'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { style: { display: 'flex', justifyContent: 'flex-end' } },
	                            _react2.default.createElement(_Button2.default, { text: 'Book Online', color: 'primary', clicked: function clicked() {
	                                    return (0, _gatsbyLink.navigateTo)('/en/booking');
	                                } })
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.MoreInfoItem, style: {
	                            backgroundImage: 'url(' + _iconOrloge2.default + ')', backgroundRepeat: 'no-repeat', backgroundPosition: 'top right', backgroundColor: '#fff'
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemTitle },
	                        'Consultation Schedules'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: _ContentModule2.default.MoreInfoItemBody, style: { padding: 20 } },
	                        _react2.default.createElement(
	                            'p',
	                            { className: _ContentModule2.default.Horaire },
	                            'Monday to Friday: ',
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                '9AM to 12PM'
	                            ),
	                            ' et ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                '1PM ro 5PM'
	                            ),
	                            ' ',
	                            _react2.default.createElement('br', null),
	                            'Closed on weekends'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentModule = __webpack_require__(20);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _arrowRight = __webpack_require__(106);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: { backgroundColor: '#f6f6f6' } },
	        _react2.default.createElement(
	            'div',
	            { style: { maxWidth: 1170, padding: '40px 20px', margin: 'auto', display: 'flex' }, className: '' },
	            _react2.default.createElement(
	                'div',
	                { className: _ContentModule2.default.ServiceWrapper },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { margin: '0 0 10px 0' } },
	                    'Therapeutic Services'
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Discover what\'s best for you'
	                ),
	                _react2.default.createElement('div', { style: { width: 100, height: 2, backgroundColor: '#1689DF', marginBottom: 40 } }),
	                _react2.default.createElement(
	                    'p',
	                    { style: { textAlign: 'left' } },
	                    'Our team takes pride in helping you. Our expertise spans the spectrum of psychological problems and conditions, from the most basic to the most complex. This includes:'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _ContentModule2.default.ServiceList },
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Anxieties'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Phobias and fears'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Relationship difficulties'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Depressions'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Family problems'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Burnout'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Professional difficulties'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Identity concerns'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Traumas'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Lack of self-esteem'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement('img', { src: _arrowRight2.default }),
	                            ' Addictions'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'The above list is not exhaustive, and we will gladly do our best to help you in your difficulties.'
	                )
	            )
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PsychoEducation = exports.TherapieFamille = exports.TherapieCouple = exports.TherapieIndividuelle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentModule = __webpack_require__(20);
	
	var _ContentModule2 = _interopRequireDefault(_ContentModule);
	
	var _iconDone = __webpack_require__(109);
	
	var _iconDone2 = _interopRequireDefault(_iconDone);
	
	var _therapieIndividuelleImage = __webpack_require__(118);
	
	var _therapieIndividuelleImage2 = _interopRequireDefault(_therapieIndividuelleImage);
	
	var _therapieDeCouple = __webpack_require__(116);
	
	var _therapieDeCouple2 = _interopRequireDefault(_therapieDeCouple);
	
	var _therapieFamiliale = __webpack_require__(117);
	
	var _therapieFamiliale2 = _interopRequireDefault(_therapieFamiliale);
	
	var _psychoeducation = __webpack_require__(114);
	
	var _psychoeducation2 = _interopRequireDefault(_psychoeducation);
	
	var _pourquoiLeCpm = __webpack_require__(113);
	
	var _pourquoiLeCpm2 = _interopRequireDefault(_pourquoiLeCpm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageWhyUs,
	            style: { backgroundImage: 'url(' + _pourquoiLeCpm2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'div',
	                { className: '' },
	                _react2.default.createElement(
	                    'h1',
	                    { style: { margin: '0 0 40px 0' } },
	                    'Why choose the CPM?'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'We are professionals'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'All our therapists are accredited and experienced professionals. Our therapists have met rigorous selection criteria and are carefully hand-picked to ensure the best support.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'We are fast'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Having to wait days or weeks until your first appointment can be frustrating, especially during times of vulnerability. With CPM you will get an appointment as soon as possible.'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                    'h4',
	                    { className: _ContentModule2.default.WhyItemTitle },
	                    _react2.default.createElement('img', { src: _iconDone2.default, className: _ContentModule2.default.CheckIcon }),
	                    'Affordable service'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Our rates are affordable and we can also be covered by insurance.'
	                )
	            )
	        )
	    );
	};
	
	var TherapieIndividuelle = exports.TherapieIndividuelle = function TherapieIndividuelle() {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement(
	            'div',
	            { className: [_ContentModule2.default.SideContentWrapper, _ContentModule2.default.TherapieIndividuelle].join(' ') },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Individual Therapy'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Individual therapy aims at treating the individual\'s emotional, relational and psychological disorders. This treatment is for both teens and adults.'
	            )
	        ),
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _therapieIndividuelleImage2.default + ')' }
	        })
	    );
	};
	
	var TherapieCouple = exports.TherapieCouple = function TherapieCouple() {
	    return _react2.default.createElement(
	        'div',
	        { className: [_ContentModule2.default.SideImageWrapper, _ContentModule2.default.TherapieCoupleWrapper].join(' ') },
	        _react2.default.createElement('div', {
	            className: [_ContentModule2.default.SideImageTherapies, _ContentModule2.default.TherapieCouple].join(" "),
	            style: { backgroundImage: 'url(' + _therapieDeCouple2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Couple Therapy'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Couple therapy is intended for couples, whether married or not, and for people facing difficulties living together. It aims to help couples overcome relationship problems and strengthen emotional closeness and restore their relationship to a healthier and more balanced level of functioning.'
	            )
	        )
	    );
	};
	
	var TherapieFamille = exports.TherapieFamille = function TherapieFamille() {
	    return _react2.default.createElement(
	        'div',
	        { className: _ContentModule2.default.SideImageWrapper },
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Family Therapy'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'Family therapy targets the family as a social system. It is aimed at all families having relationship difficulties in improving mutual understanding and increasing the emotional support of family members, especially during the transition phases (children\'s adolescence, separation of parents, unemployment, retirement, etc...) and difficult events, such as death or serious illness in the family.'
	            )
	        ),
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _therapieFamiliale2.default + ')' }
	        })
	    );
	};
	
	var PsychoEducation = exports.PsychoEducation = function PsychoEducation() {
	    return _react2.default.createElement(
	        'div',
	        { className: [_ContentModule2.default.SideImageWrapper, _ContentModule2.default.PsychoeducationWrapper].join(' ') },
	        _react2.default.createElement('div', {
	            className: _ContentModule2.default.SideImageTherapies,
	            style: { backgroundImage: 'url(' + _psychoeducation2.default + ')' }
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: _ContentModule2.default.SideContentWrapper },
	            _react2.default.createElement(
	                'h2',
	                null,
	                'Psychoeducation'
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                'We provide psychoeducation on a variety of issues related to the education of children and teenagers. The goal is to help parents effectively manage the behavioural and emotional difficulties of their child or teen.'
	            )
	        )
	    );
	};

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FormWrapper":"src-componentsEn-Forms----Forms-module---FormWrapper---1yGDG","FormBody":"src-componentsEn-Forms----Forms-module---FormBody---1FK56","InputStyle":"src-componentsEn-Forms----Forms-module---InputStyle---n4qbV","SelectInput":"src-componentsEn-Forms----Forms-module---SelectInput---2UvjP","TextArea":"src-componentsEn-Forms----Forms-module---TextArea---1bd5K","Label":"src-componentsEn-Forms----Forms-module---Label---1ZvJm","FormRowWrapper":"src-componentsEn-Forms----Forms-module---FormRowWrapper---3k0_x","FormRow":"src-componentsEn-Forms----Forms-module---FormRow---3NrFB","ProgressItem":"src-componentsEn-Forms----Forms-module---ProgressItem---3gbR_","Active":"src-componentsEn-Forms----Forms-module---Active---2c1Ck"};

/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _FormsModule = __webpack_require__(39);
	
	var _FormsModule2 = _interopRequireDefault(_FormsModule);
	
	var _arrow_down24px = __webpack_require__(56);
	
	var _arrow_down24px2 = _interopRequireDefault(_arrow_down24px);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_React$Component) {
	    _inherits(_class, _React$Component);
	
	    function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	            firstName: '',
	            lastName: '',
	            phoneNumber: '',
	            email: '',
	            domaine: 'Individual Therapy'
	        }, _this.handleInputChange = function (e) {
	            var state = _extends({}, _this.state);
	            state[e.target.getAttribute('name')] = e.target.value;
	            _this.setState(_extends({}, state));
	        }, _this.handleLeadFormClicked = function () {
	            (0, _gatsbyLink.navigateTo)({
	                pathname: '/en/booking',
	                data: {
	                    from: 'homepage',
	                    state: _this.state
	                }
	            });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _class.prototype.render = function render() {
	        var _this2 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: _FormsModule2.default.FormWrapper },
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        textTransform: 'uppercase',
	                        backgroundColor: '#0071BC', color: 'white',
	                        height: 60, display: 'flex', alignItems: 'center', justifyContent: 'center'
	                    } },
	                'Appointment Form'
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: _FormsModule2.default.FormBody },
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'First Name(s)'
	                    ),
	                    _react2.default.createElement('input', { name: 'firstName', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Surname(s)'
	                    ),
	                    _react2.default.createElement('input', { name: 'lastName', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Phone Number'
	                    ),
	                    _react2.default.createElement('input', { name: 'phoneNumber', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 10 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Email'
	                    ),
	                    _react2.default.createElement('input', { name: 'email', className: _FormsModule2.default.InputStyle, onChange: function onChange(e) {
	                            return _this2.handleInputChange(e);
	                        } })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { marginBottom: 20 } },
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Domain'
	                    ),
	                    _react2.default.createElement(
	                        'select',
	                        { name: 'domaine', className: _FormsModule2.default.SelectInput, style: { backgroundImage: 'url(' + _arrow_down24px2.default + ')' }, onChange: function onChange(e) {
	                                return _this2.handleInputChange(e);
	                            } },
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Individual Therapy' },
	                            'Individual Therapy'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Couple Therapy' },
	                            'Couple Therapy'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Family Therapy' },
	                            'Family Therapy'
	                        ),
	                        _react2.default.createElement(
	                            'option',
	                            { value: 'Teletherapy' },
	                            'Teletherapy'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(_Button2.default, { color: 'primary', text: 'Book an Appointment', styles: styles, clicked: this.handleLeadFormClicked })
	                )
	            )
	        );
	    };
	
	    return _class;
	}(_react2.default.Component);
	
	exports.default = _class;
	
	
	var styles = {
	    width: "100%",
	    borderRadius: 0
	};
	module.exports = exports['default'];

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _callIcon = __webpack_require__(107);
	
	var _callIcon2 = _interopRequireDefault(_callIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                backgroundColor: '#FF7F00',
	                height: 58,
	                width: 58,
	                padding: '18px 12px 8px',
	                position: 'fixed',
	                bottom: 20,
	                right: 20,
	                borderRadius: '50%'
	            }, onClick: function onClick() {
	                if (window.gtag) {
	                    gtag('event', 'conversion', {
	                        'send_to': 'AW-997202270/gOfzCM28rYQBEN6ywNsD'
	                    });
	                    console.log('oui');
	                } else {
	                    console.log('non');
	                }
	            } },
	        _react2.default.createElement(
	            'a',
	            { href: 'tel:+16132525227' },
	            _react2.default.createElement('img', { src: _callIcon2.default, style: { width: 34, margin: 0 } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fillFormIcon = __webpack_require__(108);
	
	var _fillFormIcon2 = _interopRequireDefault(_fillFormIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { style: {
	                display: 'flex',
	                alignItems: 'center',
	                justifyContent: 'center',
	                backgroundColor: '#4cae4c',
	                height: 58,
	                width: 58,
	                padding: '18px 12px 8px',
	                position: 'fixed',
	                bottom: 20,
	                right: 'calc(20px + 58px + 10px)',
	                borderRadius: '50%'
	            } },
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/reservation' },
	            _react2.default.createElement('img', { src: _fillFormIcon2.default, style: { width: 34, margin: 0 } })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(2);
	
	var _reactPlayer = __webpack_require__(100);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _Button = __webpack_require__(13);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _LeadForm = __webpack_require__(160);
	
	var _LeadForm2 = _interopRequireDefault(_LeadForm);
	
	var _google_conversion_mobile_call = __webpack_require__(11);
	
	var _google_conversion_mobile_call2 = _interopRequireDefault(_google_conversion_mobile_call);
	
	var _Mozaique = __webpack_require__(163);
	
	var _Mozaique2 = _interopRequireDefault(_Mozaique);
	
	var _MozaiqueModule = __webpack_require__(193);
	
	var _MozaiqueModule2 = _interopRequireDefault(_MozaiqueModule);
	
	var _videos = __webpack_require__(80);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroSection = function HeroSection(props) {
	    return _react2.default.createElement(
	        _Mozaique2.default,
	        props,
	        _react2.default.createElement(
	            'div',
	            { className: _MozaiqueModule2.default.Wrapper },
	            _react2.default.createElement(
	                'div',
	                { className: _MozaiqueModule2.default.InnerContentLeft },
	                _react2.default.createElement(
	                    'h1',
	                    { className: _MozaiqueModule2.default.H1 },
	                    'Counselling and Therapy Service'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _MozaiqueModule2.default.SubH1 },
	                    'Find out how the CPM can help you'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _MozaiqueModule2.default.VideoWrapper },
	                    _react2.default.createElement(_reactPlayer2.default, {
	                        url: _videos.HERO_VIDEO_EN,
	                        config: {
	                            wistia: {
	                                options: {
	                                    playerColor: "#1689DF"
	                                }
	                            }
	                        },
	                        width: '100%',
	                        height: '100%'
	                    })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: { fontSize: '0.8rem', padding: '10px 0 0' }, className: _MozaiqueModule2.default.VideoFooterText },
	                    _react2.default.createElement(
	                        'div',
	                        { style: {
	                                fontSize: '0.9rem',
	                                backgroundColor: "#04040487",
	                                padding: '0 10px',
	                                fontWeight: 500,
	                                display: 'inline-block'
	                            } },
	                        'Our consultations are partially reimbursable by certain insurances.'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { style: {
	                                backgroundColor: "#04040487",
	                                padding: '0 10px',
	                                display: 'inline-block'
	                            } },
	                        'Spots are limited due to the high demand for counselling services.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: { padding: 10, position: props.position, top: props.top }, className: _MozaiqueModule2.default.FullLeadForm },
	                _react2.default.createElement(_LeadForm2.default, props)
	            ),
	            _react2.default.createElement(MobileHeroCallToAction, props)
	        )
	    );
	};
	
	var MobileHeroCallToAction = function MobileHeroCallToAction(props) {
	    return _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center', padding: 20 }, className: _MozaiqueModule2.default.MobileCallToAction },
	        _react2.default.createElement(_Button2.default, { color: 'primary', text: 'R\xE9servez une Consultation en Ligne', clicked: function clicked() {
	                return (0, _gatsbyLink.navigateTo)('/reservation');
	            }, styles: buttonStyles }),
	        _react2.default.createElement(
	            'div',
	            { style: { padding: 10 } },
	            _react2.default.createElement(
	                'h4',
	                { style: { color: "#fff", marginBottom: 10, fontSize: '0.9rem' } },
	                'Ou appelez nous maintenant'
	            ),
	            _react2.default.createElement(
	                'a',
	                { href: 'tel:+16132525227', onClick: function onClick() {
	                        (0, _google_conversion_mobile_call2.default)();
	                    } },
	                _react2.default.createElement(_Button2.default, { color: 'secondary', text: '613-252-5227', styles: buttonStyles, clicked: function clicked() {
	                        return (0, _google_conversion_mobile_call2.default)();
	                    } })
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { style: { fontSize: '0.7rem', padding: '10px 0 0', color: '#fff' } },
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        fontSize: '0.9rem',
	                        backgroundColor: "#04040487",
	                        padding: '4px 10px 0',
	                        fontWeight: 500
	                    } },
	                'Our consultations are partially reimbursable by certain insurances.'
	            ),
	            _react2.default.createElement(
	                'div',
	                { style: {
	                        backgroundColor: "#04040487",
	                        padding: '0 10px 4px'
	                    } },
	                'Spots are limited due to the high demand for counselling services.'
	            )
	        )
	    );
	};
	
	var buttonStyles = {
	    padding: 10,
	    minWidth: 200
	};
	
	exports.default = HeroSection;
	module.exports = exports['default'];

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mozaiqueMobile = __webpack_require__(111);
	
	var _mozaiqueMobile2 = _interopRequireDefault(_mozaiqueMobile);
	
	var _mozaique = __webpack_require__(112);
	
	var _mozaique2 = _interopRequireDefault(_mozaique);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    _class.prototype.render = function render() {
	        var _props = this.props,
	            isMobile = _props.isMobile,
	            windowWidth = _props.windowWidth;
	
	        return _react2.default.createElement(
	            'div',
	            { style: {
	                    backgroundImage: 'url(' + (windowWidth < 842 ? _mozaiqueMobile2.default : _mozaique2.default) + ')',
	                    boxShadow: "inset 0 0 0 10000px rgba(0,0,0,.65)",
	                    backgroundSize: "cover",
	                    backgroundPosition: "center"
	
	                } },
	            this.props.children
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Wrapper":"src-componentsEn-HeroSection----Mozaique-module---Wrapper---3nMtL","InnerContentLeft":"src-componentsEn-HeroSection----Mozaique-module---InnerContentLeft---3a2Iy","FullLeadForm":"src-componentsEn-HeroSection----Mozaique-module---FullLeadForm---1oVWn","VideoFooterText":"src-componentsEn-HeroSection----Mozaique-module---VideoFooterText---1ImGA","MobileCallToAction":"src-componentsEn-HeroSection----Mozaique-module---MobileCallToAction---21RnI","SubH1":"src-componentsEn-HeroSection----Mozaique-module---SubH1---3pZMF","H1":"src-componentsEn-HeroSection----Mozaique-module---H1---21VCA","VideoWrapper":"src-componentsEn-HeroSection----Mozaique-module---VideoWrapper---3AeJz","H1Call":"src-componentsEn-HeroSection----Mozaique-module---H1Call---1R80Q","H1Ottawa":"src-componentsEn-HeroSection----Mozaique-module---H1Ottawa---1uUMp","SubH1Ottawa":"src-componentsEn-HeroSection----Mozaique-module---SubH1Ottawa---3Qi9l"};

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIframe = __webpack_require__(52);
	
	var _reactIframe2 = _interopRequireDefault(_reactIframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	        var width = _ref.width,
	            height = _ref.height,
	            src = _ref.src;
	        return _react2.default.createElement(_reactIframe2.default, {
	                width: width,
	                height: height,
	                url: src,
	                display: 'initial',
	                position: 'relative',
	                allowFullScreen: true });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CallAction = __webpack_require__(161);
	
	var _CallAction2 = _interopRequireDefault(_CallAction);
	
	var _FillFormAction = __webpack_require__(162);
	
	var _FillFormAction2 = _interopRequireDefault(_FillFormAction);
	
	var _MobileActionsModule = __webpack_require__(194);
	
	var _MobileActionsModule2 = _interopRequireDefault(_MobileActionsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	    return _react2.default.createElement(
	        'div',
	        { className: _MobileActionsModule2.default.ActionWrapper },
	        _react2.default.createElement(_CallAction2.default, null),
	        _react2.default.createElement(_FillFormAction2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"ActionWrapper":"src-componentsEn-MobileActions----MobileActions-module---ActionWrapper---1F8HI"};

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(15);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Carousel = __webpack_require__(151);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _HomePage = __webpack_require__(154);
	
	var _HomePage2 = _interopRequireDefault(_HomePage);
	
	var _MoreInfo = __webpack_require__(157);
	
	var _MoreInfo2 = _interopRequireDefault(_MoreInfo);
	
	var _Footer = __webpack_require__(79);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Hero = __webpack_require__(318);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Services = __webpack_require__(158);
	
	var _Services2 = _interopRequireDefault(_Services);
	
	var _WhyUs = __webpack_require__(159);
	
	var _WhyUs2 = _interopRequireDefault(_WhyUs);
	
	var _Listen = __webpack_require__(156);
	
	var _Listen2 = _interopRequireDefault(_Listen);
	
	var _HowToGetStarted = __webpack_require__(155);
	
	var _HowToGetStarted2 = _interopRequireDefault(_HowToGetStarted);
	
	var _Benefits = __webpack_require__(152);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	var _GetStarted = __webpack_require__(153);
	
	var _GetStarted2 = _interopRequireDefault(_GetStarted);
	
	var _MobileActions = __webpack_require__(164);
	
	var _MobileActions2 = _interopRequireDefault(_MobileActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, _class);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	            isMobile: false,
	            windowWidth: null,
	            isLoading: true,
	            scrollPosition: 0
	        }, _this.updateDeviceState = function () {
	            return _this.setState({ isMobile: window.innerWidth < 768, windowWidth: window.innerWidth });
	        }, _this.updateScrollPosition = function () {
	            return _this.setState({ scrollPosition: window.scrollY });
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _class.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        this.setState({
	            isMobile: window.innerWidth < 768,
	            windowWidth: window.innerWidth,
	            isLoading: false
	        }, function () {
	            window.addEventListener("resize", _this2.updateDeviceState);
	            window.addEventListener("scroll", _this2.updateScrollPosition);
	        });
	    };
	
	    _class.prototype.componentWillUnmount = function componentWillUnmount() {
	        window.removeEventListener("resize", this.updateDeviceState);
	        window.removeEventListener("scroll", this.updateScrollPosition);
	    };
	
	    _class.prototype.render = function render() {
	
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement('html', { lang: 'en' }),
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Counselling and Therapy Service in Ottawa and Gatineau Region'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Are you going through hard times? If so, you are not alone. Take the first step towards well-being by talking to a professional who will help you regain control and ...' })
	            ),
	            _react2.default.createElement(_Hero2.default, _extends({}, this.state, this.props)),
	            _react2.default.createElement(_Carousel2.default, null),
	            _react2.default.createElement(_HomePage2.default, null),
	            _react2.default.createElement(_Services2.default, null),
	            _react2.default.createElement(_WhyUs2.default, null),
	            _react2.default.createElement(_Listen2.default, null),
	            _react2.default.createElement(_WhyUs.TherapieIndividuelle, null),
	            _react2.default.createElement(_WhyUs.TherapieCouple, null),
	            _react2.default.createElement(_WhyUs.TherapieFamille, null),
	            _react2.default.createElement(_WhyUs.PsychoEducation, null),
	            _react2.default.createElement(_HowToGetStarted2.default, null),
	            _react2.default.createElement(_Benefits2.default, null),
	            _react2.default.createElement(_GetStarted2.default, null),
	            _react2.default.createElement(_MoreInfo2.default, _extends({ isMobile: this.state.isMobile }, this.props)),
	            _react2.default.createElement(_Footer2.default, null),
	            this.state.scrollPosition > 600 ? _react2.default.createElement(_MobileActions2.default, null) : null
	        );
	    };
	
	    return _class;
	}(_react.Component);
	
	exports.default = _class;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-index-js-7881011d634e09ca3e69.js